import { StatusBar } from "expo-status-bar";
import React from "react";
import ENV from "app/utils/ENV";
import {
  StyleSheet,
  View,
  ScrollView,
  ActivityIndicator,
  Animated,
} from "react-native";
import Text from "app/components/Text";
import TouchableOpacity from "app/components/TouchableOpacity";
import apiActions from "app/utils/apiActions";
import valueActions from "app/utils/valueActions";
import valueHelpers from "app/utils/valueHelpers";
import colorHelpers from "app/utils/colorHelpers";
import * as RootNavigation from "app/utils/RootNavigation.js";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";

import TextInput from "app/components/TextInput";
import ValueComposer from "app/components/ValueComposer";
// import ValueListItem from "app/components/ValueListItem";
import QuickComposer from "app/components/QuickComposer";
import HoverableTooltip from "app/components/HoverableTooltip";
import { Feather, AntDesign } from "@expo/vector-icons";

import { StyleContext } from "app/contexts/Style";

export default class Intro extends React.Component {
  static contextType = StyleContext;
  constructor(props) {
    super(props);
    this.state = {
      // id,
      // value,
      values: [
        { id: "p-0", text: "", icon: "", color: "", parent_ids: [] },
        { id: "c-99", text: "", icon: "", color: "", parent_ids: ["c-98"] },
        { id: "p-1", text: "", icon: "", color: "", parent_ids: ["p-0"] },
        { id: "c-98", text: "", icon: "", color: "", parent_ids: [] },
      ],
      submitting: false,
      error: false,
      // confirmed1: true,
      // confirmed2: true,
      mobileStageAnim: new Animated.Value(0),
      stage1Anim: new Animated.Value(0),
      stage2Anim1: new Animated.Value(0),
      stage2Anim2: new Animated.Value(0),
      stage3Anim1: new Animated.Value(0),
      stage3Anim2: new Animated.Value(0),
      stage3Anim3: new Animated.Value(0),
      stage3Anim4: new Animated.Value(0),
    };
  }

  async componentDidMount() {
    this.runStage1Anim();
    // this.runStage2Anim();
    // this.runStage3Anim();
  }

  handleChangeValue = (key, val) => {
    let { value } = this.state;
    value[key] = val;
    this.setState({ value });
  };

  render() {
    let { values, submitting } = this.state;
    let { stage2, stage3 } = this.state;
    let { mobileStageAnim } = this.state;
    let { stage1Anim } = this.state;
    let { stage2Anim1, stage2Anim2 } = this.state;
    let { stage3Anim1, stage3Anim2, stage3Anim3, stage3Anim4 } = this.state;

    const mobileAnimLeft = mobileStageAnim.interpolate({
      inputRange: [0, 3],
      outputRange: [this.context.sizes.WIDTH, -this.context.sizes.WIDTH * 2],
    });
    const stage1AnimLeft = stage1Anim.interpolate({
      inputRange: [0, 1],
      outputRange: [-this.context.sizes.WIDTH / 2, 0],
    });
    const stage2AnimLeft = stage2Anim2.interpolate({
      inputRange: [0, 1],
      outputRange: [-this.context.sizes.WIDTH / 2, 0],
    });
    const stage3AnimLeft = stage3Anim2.interpolate({
      inputRange: [0, 1],
      outputRange: [-this.context.sizes.WIDTH / 2, 0],
    });
    // const stage3AnimLeft2 = stage3Anim4.interpolate({
    //   inputRange: [0, 1],
    //   outputRange: [-this.context.sizes.WIDTH / 2, 0],
    // });

    let composerWidth = ENV.WEB
      ? 360
      : this.context.sizes.WIDTH - 70 - this.context.sizes.base * 2;

    return (
      <KeyboardAwareScrollView
        extraScrollHeight={100}
        innerRef={(ref) => (this.scroller = ref)}
        keyboardShouldPersistTaps={"always"}
      >
        <View
          style={{
            flex: 1,
            flexDirection: ENV.WEB ? "row" : "column",
            justifyContent: "flex-start",
          }}
        >
          {[
            <Animated.View
              key={"1"}
              style={[
                this.styles().container,
                ENV.WEB
                  ? {
                      maxWidth: 500,
                      minWidth: 300,
                    }
                  : {
                      flexShrink: 0,
                      width: this.context.sizes.WIDTH * 3,
                      // height: this.context.sizes.HEIGHT / 3,
                      height: "auto",
                      flexDirection: "row",
                      // justifyContent: "flex-start",
                      // alignItems: "center",
                      paddingHorizontal: 0,
                      transform: [
                        {
                          translateX: mobileAnimLeft,
                        },
                      ],
                    },
              ]}
            >
              <View style={[this.styles().itemRow]}>
                <View style={this.styles().gutter}>
                  <Animated.View
                    style={{
                      transform: [
                        {
                          scale: stage2Anim1,
                        },
                      ],
                    }}
                  >
                    <Feather
                      name={"check-circle"}
                      color={this.context.colors.active}
                      size={this.context.sizes.itemHeight}
                    />
                  </Animated.View>
                </View>
                <Animated.View
                  style={[
                    { flex: 1 },
                    ENV.WEB && {
                      transform: [{ translateX: stage1AnimLeft }],
                    },
                  ]}
                >
                  <Text style={this.styles().header}>Getting Started</Text>
                  <Text>
                    {`Let's begin by identifying one value and one activity.\nDon't worry if they're not related.`}
                  </Text>
                </Animated.View>
              </View>

              <Animated.View
                style={[
                  this.styles().itemRow,
                  ENV.WEB && {
                    transform: [
                      {
                        translateX: stage2AnimLeft,
                      },
                    ],
                  },
                ]}
              >
                <View style={this.styles().gutter}>
                  <Animated.View
                    style={{ transform: [{ scale: stage3Anim1 }] }}
                  >
                    <Feather
                      name={"check-circle"}
                      color={this.context.colors.active}
                      size={this.context.sizes.itemHeight}
                    />
                  </Animated.View>
                </View>
                <View style={{ flex: 1 }}>
                  <Text style={this.styles().header}>Providing Context</Text>
                  <Text>
                    {`Looking good. Now let's give each of those a bit of context.`}
                  </Text>
                </View>
              </Animated.View>

              <Animated.View
                style={[
                  this.styles().itemRow,
                  ENV.WEB && {
                    transform: [
                      {
                        translateX: stage3AnimLeft,
                      },
                    ],
                  },
                ]}
              >
                <View style={this.styles().gutter}>
                  <Animated.View
                    style={{ transform: [{ scale: stage3Anim3 }] }}
                  >
                    <Feather
                      name={"check-circle"}
                      color={this.context.colors.active}
                      size={this.context.sizes.itemHeight}
                    />
                  </Animated.View>
                </View>
                <View style={{ flex: 1 }}>
                  <Text style={this.styles().header}>You're Ready</Text>
                  <Text>
                    {/*`You can continue to add more relationships and whenever you're ready, continue to your dashboard.`*/}
                    {`You'll be able to add more relationships from your dashboard.`}
                  </Text>
                  <Animated.View
                    style={{
                      marginTop: 50,
                      alignSelf: "flex-start",
                      flex: 1,
                      flexDirection: "row",
                      alignItems: "center",
                      // transform: [{ scale: stage3Anim3 }],
                      transform: [
                        {
                          scale: stage3Anim4,
                        },
                      ],
                    }}
                  >
                    <Text
                      button
                      disabled={this.state.submitting}
                      onPress={this.continue}
                      style={{
                        marginRight: this.context.sizes.base,
                        backgroundColor: this.context.colors.active,
                        color: this.context.colors.lightForeground,
                        // borderColor: this.context.colors.active,
                        // borderWidth: 2,
                      }}
                    >
                      Continue
                    </Text>
                    {this.state.submitting && (
                      <ActivityIndicator color={this.context.colors.active} />
                    )}
                  </Animated.View>
                </View>
              </Animated.View>
            </Animated.View>,
            <View
              key={"2"}
              // style={[{ borderWidth: 2, borderColor: "red", overflowX: "visible" }]}
              style={[
                this.styles().container,
                { minHeight: this.context.sizes.HEIGHT * 0.5 },
              ]}
            >
              <View style={[this.styles().item, { zIndex: 2 }]}>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    // justifyContent: "space-between",
                    zIndex: 3,
                  }}
                >
                  {this.renderTooltip("value")}
                  <Text style={this.styles().header}>
                    High-level moral value
                  </Text>
                </View>
                <View style={{ zIndex: 2 }}>
                  <ValueComposer
                    placeholder={`Value you believe in`}
                    value={values[0]}
                    onUpdateValue={(value) => this.updateValue(0, value)}
                    width={composerWidth}
                    setConfirmed={(confirmed1) => {
                      let stage2 = confirmed1 && this.state.confirmed2;
                      this.setState({ confirmed1 });
                      if (stage2) this.runStage2Anim();
                    }}
                  />
                </View>

                {stage2 &&
                  this.renderIndentation(stage2, values[0].color, () => (
                    <ValueComposer
                      placeholder={`Action to engage`}
                      value={values[2]}
                      onUpdateValue={(value) => this.updateValue(2, value)}
                      width={composerWidth}
                      setConfirmed={(confirmed3) => {
                        let stage3 = confirmed3 && this.state.confirmed4;
                        this.setState({ confirmed3, stage3 });
                        if (stage3) this.runStage3Anim();
                      }}
                    />
                  ))}
              </View>

              <View style={[this.styles().item]}>
                <View>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      // justifyContent: "space-between",
                      zIndex: 3,
                    }}
                  >
                    {this.renderTooltip("habit")}
                    <Text style={this.styles().header}>
                      Ongoing actionable habit
                    </Text>
                  </View>

                  {stage2 && (
                    <View style={{ zIndex: 2 }}>
                      <ValueComposer
                        placeholder={`Value to serve`}
                        value={values[3]}
                        onUpdateValue={(value) => this.updateValue(3, value)}
                        width={composerWidth}
                        setConfirmed={(confirmed4) => {
                          let stage3 = confirmed4 && this.state.confirmed3;
                          this.setState({ confirmed4, stage3 });
                          if (stage3) this.runStage3Anim();
                        }}
                      />
                    </View>
                  )}

                  {this.renderIndentation(stage2, values[3].color, () => (
                    <ValueComposer
                      value={values[1]}
                      placeholder={`Habit to practice`}
                      onUpdateValue={(value) => this.updateValue(1, value)}
                      width={composerWidth}
                      setConfirmed={(confirmed2) => {
                        let stage2 = confirmed2 && this.state.confirmed1;
                        this.setState({ confirmed2 });
                        if (stage2) this.runStage2Anim();
                      }}
                    />
                  ))}
                </View>
              </View>
            </View>,
          ].sort((a, b) => {
            if (ENV.WEB) {
              return a.key > b.key;
            } else {
              return a.key < b.key;
            }
          })}
        </View>
      </KeyboardAwareScrollView>
    );
  }

  renderIndentation = (indent = false, colorName, children) => {
    return (
      <View
        style={[
          {
            flexDirection: "row",
          },
        ]}
      >
        {indent && (
          <View style={this.styles().indentationSquare}>
            <View
              style={[
                this.styles().indentation,
                {
                  borderColor: colorHelpers.modifyHex(
                    valueHelpers.colorAsHex(
                      colorName,
                      this.context.colorScheme
                    ) || this.context.colors.trim,
                    this.context.colors.darkenBy
                  ),
                },
              ]}
            />
          </View>
        )}
        <View style={[indent && { marginTop: this.context.sizes.base }]}>
          {children()}
        </View>
      </View>
    );
  };

  updateValue = (index, value) => {
    let { values } = this.state;
    values[index] = { ...value, parent_ids: values[index].parent_ids };
    this.setState({ values });
  };

  renderTooltip = (type) => {
    let text = "";
    if (type == "value") {
      text =
        "Try thinking of something that ressonates. It could be a value, mantra, goal, or anything you'd like to see more of in your life.";
    } else if (type == "habit") {
      text =
        "This can be a healthy habit you already have, one you'd like to start, or even a new activity you'd like to try out.";
    }
    return (
      <View
        style={[
          { position: "absolute", zIndex: 3 },
          ENV.WEB
            ? {
                left: -this.context.sizes.large,
              }
            : {
                right: this.context.sizes.large,
              },
        ]}
      >
        <HoverableTooltip
          stickOnClick
          numberOfLines={99}
          style={{
            padding: this.context.sizes.base,
            width: 220,
            top: -this.context.sizes.base,
            left: undefined,
            right: this.context.sizes.large,
          }}
          // textStyle={{ textAlign: "justify" }}
          text={text}
        >
          <AntDesign
            name={`questioncircle${ENV.WEB ? "" : "o"}`}
            color={this.context.colors.trim}
            style={[
              this.styles().header,
              !ENV.WEB && {
                fontSize: this.context.sizes.large,
              },
              // { marginLeft: this.context.sizes.large },
            ]}
          />
        </HoverableTooltip>
      </View>
    );
  };

  continue = async () => {
    let { values, submitting } = this.state;
    if (submitting) return;
    this.setState({ submitting: true });
    console.log(values);
    let res = await valueActions.createIntroValues(values);
    this.setState({ submitting: false });
    console.log(res);
    if (res?.success) {
      RootNavigation.navigate("Chapters");
    }
  };

  runStage1Anim = () => {
    Animated.timing(this.state.stage1Anim, {
      toValue: 1,
      duration: 400,
      useNativeDriver: !ENV.WEB,
      delay: 1000,
    }).start();
    Animated.timing(this.state.mobileStageAnim, {
      toValue: 1,
      duration: 400,
      useNativeDriver: !ENV.WEB,
      delay: 1000,
    }).start();
  };

  runStage2Anim = () => {
    Animated.spring(this.state.stage2Anim1, {
      toValue: 1,
      bounciness: 12,
      speed: 3,
      useNativeDriver: !ENV.WEB,
      delay: 700,
    }).start(() => {
      Animated.timing(this.state.mobileStageAnim, {
        toValue: 2,
        duration: 400,
        useNativeDriver: !ENV.WEB,
        delay: 1000,
      }).start();
      Animated.timing(this.state.stage2Anim2, {
        toValue: 1,
        duration: 400,
        useNativeDriver: !ENV.WEB,
        delay: 700,
      }).start(() => {
        setTimeout(() => {
          this.setState({ stage2: true });
        }, 700);
      });
    });
  };

  runStage3Anim = () => {
    Animated.spring(this.state.stage3Anim1, {
      toValue: 1,
      bounciness: 12,
      speed: 3,
      useNativeDriver: !ENV.WEB,
      delay: 700,
    }).start(() => {
      Animated.timing(this.state.mobileStageAnim, {
        toValue: 3,
        duration: 400,
        useNativeDriver: !ENV.WEB,
        delay: 1000,
      }).start();
      Animated.timing(this.state.stage3Anim2, {
        toValue: 1,
        duration: 500,
        useNativeDriver: !ENV.WEB,
        delay: 700,
      }).start(() => {
        Animated.spring(this.state.stage3Anim3, {
          toValue: 1,
          bounciness: 12,
          speed: 3,
          useNativeDriver: !ENV.WEB,
          delay: 700,
        }).start();
        Animated.spring(this.state.stage3Anim4, {
          toValue: 1,
          bounciness: 12,
          speed: 3,
          useNativeDriver: !ENV.WEB,
          delay: 900,
        }).start();
      });
    });
  };

  styles = () => ({
    container: {
      flex: 1,
      padding: this.context.sizes.large,
      // justifyContent: "space-around",
      alignItems: "center",
      // borderWidth: 2,
      // borderColor: "red",
    },
    header: {
      fontWeight: "bold",
      marginBottom: this.context.sizes.base,
    },
    itemRow: {
      flexDirection: "row",
      alignSelf: "stretch",
      width: ENV.WEB ? 450 : this.context.sizes.WIDTH,
      // maxWidth: "100%",
      paddingLeft: this.context.sizes.base,
      paddingRight: ENV.WEB ? 0 : this.context.sizes.large * 2,
      marginTop: 50,
    },
    item: {
      minWidth: ENV.WEB ? 350 : this.context.sizes.WIDTH,
      marginTop: ENV.WEB ? 100 : 40,
      paddingHorizontal: ENV.WEB ? 0 : this.context.sizes.base,
    },
    gutter: {
      width: this.context.sizes.itemHeight,
      marginRight: this.context.sizes.large,
      alignItems: "center",
      marginLeft: ENV.WEB ? 0 : this.context.sizes.base,
    },
    indentationSquare: {
      width: 70,
      height: 40,
    },
    indentation: {
      // zIndex: -1,
      borderLeftWidth: 2,
      borderBottomWidth: 2,
      borderBottomLeftRadius: this.context.sizes.smallBorderRadius,
      position: "absolute",
      top: 0,
      left: 35,
      height: 35,
      width: 35,
    },
    outdentation: {
      zIndex: -1,
      borderLeftWidth: 2,
      borderBottomWidth: 2,
      borderRadius: this.context.sizes.smallBorderRadius,
      position: "absolute",
      top: -25,
      left: -25,
      height: 83,
      width: 50,
      opacity: 0,
    },
  });
}
